<template>
  <Transition name="fade">
    <div
      v-show="show"
      data-cy="chat-toast"
      class="w-64 rounded-lg bg-white px-4 py-3 text-headline shadow-lg"
    >
      <div class="flex items-start">
        <div class="flex-1">
          <p class="text-sm">{{ message || t("chat.greeting") }}</p>
        </div>
        <button
          data-cy="toast-close-button"
          class="ml-2 text-gray-400 hover:text-gray-600"
          :aria-label="t('chat.close')"
          @click="close"
        >
          <icon-x :width="18" :height="18" />
        </button>
      </div>
      <!-- Triangle pointer at bottom -->
      <div class="absolute right-6 -bottom-2 h-4 w-4 rotate-45 transform bg-white"></div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

import IconX from "@/components/icons/IconX.vue";

const { t } = useI18n();

const { show, message = "" } = defineProps<{
  show: boolean;
  message?: string;
}>();

const emit = defineEmits<{ close: [] }>();

const close = () => {
  emit("close");
};
</script>

<style scoped>
@reference "@/tailwind.css";

.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
